import * as React from "react";
import type { SVGProps } from "react";
const SvgPhoneHornWithStarOfLife = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17 1h2v3.265l2.805-1.619 1 1.732L20 5.998l2.828 1.633-1 1.732L19 7.731V11h-2V7.728l-2.856 1.649-1-1.733 2.854-1.646-2.831-1.635 1-1.732L17 4.267V1Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.258 17.783A18 18 0 0 0 17.88 23 3.12 3.12 0 0 0 21 19.88v-4.23a1 1 0 0 0-.63-.93l-5.29-2.12a1 1 0 0 0-1.23.41l-1.1 1.83a10.81 10.81 0 0 1-3.59-3.59l1.83-1.1a1 1 0 0 0 .41-1.23L9.28 3.63A1 1 0 0 0 8.35 3H4.12A3.14 3.14 0 0 0 1 6.18a18 18 0 0 0 5.258 11.603ZM3.328 5.328c.21-.21.495-.328.792-.328h3.56l1.58 3.88-1.92 1.15a1 1 0 0 0-.38 1.3 12.66 12.66 0 0 0 5.74 5.74 1 1 0 0 0 1.3-.38l1.12-1.92L19 16.32v3.56A1.11 1.11 0 0 1 17.94 21 16 16 0 0 1 3 6.12c0-.297.118-.582.328-.792Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPhoneHornWithStarOfLife;
